(function () {
    "use strict";

    /**
     * Defines a filter which displays timestamps as relative phrases for example
     * - 10 days ago
     * - a few minutes ago
     */
    angular.module("app").filter("relativeTime", RelativeTimeFilterFactory);

    class TimeagoCase {
        constructor(selector, min, max, scale) {

            this.FormatKey = scale;

            this.Matches = function (duration) {
                const value = selector(duration);
                const rounded = Math.floor(value);

                if (!max)
                    return min <= rounded;

                else
                    return min <= rounded && rounded < max;
            };

            this.GetValue = function (duration) {
                return -Math.floor(selector(duration));
            };
        }
    }

    const tresholdMatchers = [
        new TimeagoCase(d => d.asMinutes(), 1, 60, "minute"),
        new TimeagoCase(d => d.asHours(), 1, 24, "hour"),
        new TimeagoCase(d => d.asDays(), 1, 7, "day"),
        new TimeagoCase(d => d.asWeeks(), 1, 4, "week"),
    ];


    RelativeTimeFilterFactory.$inject = ["translationsService"];
    function RelativeTimeFilterFactory(translationsService) {
        return function (value) {
            const received = moment(value || null);

            if (!received.isValid())
                return "";

            const now = moment.now();

            const timeago = moment.duration(now - received);

            // If the notification is less than a minute old, show "Just now"
            if (timeago.asSeconds() <= 60)
                return translationsService.GetTranslationByKey("Moment_JustNow");

            // Use native RelativeTimeFormat
            const formatter = new Intl.RelativeTimeFormat(translationsService.CurrentLanguage);

            for (const range of tresholdMatchers.reverse()) {
                if (range.Matches(timeago)) {
                    return formatter.format(range.GetValue(timeago), range.FormatKey);
                }
            }

            // If the notification was created more than 4 weeks ago show it as a full date
            return new Intl.DateTimeFormat(translationsService.CurrentLanguage).format(value);
        };
    }
})();